var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInternalLinkArrowRight = function SvgInternalLinkArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11.377a.667.667 0 0 1 .987 0l4.448 4.753a.785.785 0 0 1 0 1.057L8.097 10.94a.667.667 0 0 1-.988 0 .784.784 0 0 1 0-1.056l3.254-3.478H0V4.912h10.363L7.11 1.434a.784.784 0 0 1 0-1.057"
  })));
};
export default SvgInternalLinkArrowRight;